$(document).on('change', '.custom-file-input', function(e) {
    // Get the file name
    const image_url_parts = $(this).val().split("\\")
    const fileName = image_url_parts[image_url_parts.length - 1];

    if(fileName) {
        // Replace the label
        $(this).next('.custom-file-label').html(fileName);
    }
});